import React, { useEffect } from "react";
import "./premiumNewsDetail.css";
import { useNavigate, useParams } from "react-router-dom";
import api, { API_URL, BACKEND_URL } from "../util/api";
import YouTubeFrame from "./youtube";

export default function PremiumNewsDetail() {
    const { id } = useParams();
    const [article, setArticle] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [relatedArticles, setRelatedArticles] = React.useState([]);
    const navigate = useNavigate();


    const fetchArticle = ({ data }) => {
        setLoading(true);


        // Fetch article details using the id
        api.get(`${API_URL}/article/${data}`).then((response) => {
            // Handle the response and update the article state
            const article = response.data.data;
            if (response.data.status === true) {

                setArticle(article);

                setRelatedArticles(response.data.related);

            }


            setLoading(false);


        });

    };

    useEffect(() => {

        fetchArticle({ data: id });
    }, []);

    if (loading) {
        return <div align="center"><h1>Loading...</h1></div>;
    }

    return (
        <>
            {article != null ? (

                <div className="pnd-container" style={{ position: "relative" }}>


                    <div className="pnd-hero" >

                        <div className="blur-bg" style={{ backgroundImage: `url(${BACKEND_URL}${article.image})` }}></div>

                        <img src={`${BACKEND_URL}${article.image}`}

                            alt="news" className="pnd-hero-img" />

                        <div className="pnd-overlay" >

                            <h1 className="pnd-title" >
                                {
                                    article.title}

                            </h1>

                            <div className="pnd-meta" > <span> {
                                article.author}

                            </span> <span>•</span> <span> {
                                article.created_at
                            }

                                </span> </div> </div>

                    </div>

                    { article.youtube != null &&

                     <div className="pnd-video-wrapper">
                            <YouTubeFrame url={article.youtube} />
                        </div>

                    }

                    <div className="pnd-content-wrapper" >
                        

                        <div className="pnd-content" >


                            <div dangerouslySetInnerHTML={{ __html: article.body }} />

                        </div>



                        <div className="pnd-sidebar" >


                            <h3 className="pnd-sidebar-title" >Related News</h3>


                            {
                                relatedArticles.map((item) => (

                                    <div key={
                                        item.id
                                    }

                                        className="pnd-related-card" onClick={() => {


                                            setArticle(null);


                                            fetchArticle({ data: item.id });
                                            // ensure viewport is at top for the new content
                                            window.scrollTo(0, 0);


                                        }} >

                                        <img src={`${BACKEND_URL}${item.image}`}
                                            alt="related"
                                        /> <div> <h4>{item.title}</h4> <span>{item.reading_time} {/* mins read */}</span> </div>


                                    </div>



                                ))
                            }

                        </div>

                    </div>

                </div>

            ) : <><h1 align="center">Article not found</h1></>}

        </>



    );
}
